export default __webpack_public_path__ + "static/media/blueDownloadIcon.62686e30.svg";